import React, { Component } from 'react';
import styles from './NavHeader.module.scss';
import Link from './Link';
import { injectIntl } from 'gatsby-plugin-intl';
import { LANGS, HEADER_NAV, NAVS } from '../config';
import { navigate } from 'gatsby';

class NavHeader extends Component {
  toggleLan = () => {
    let { location, intl } = this.props;
    let { pathname, search, hash } = location;
    const target = intl.locale === 'zh' ? '/en' : '/zh';
    const prefix = typeof __PATH_PREFIX__ !== 'undefined' ? __PATH_PREFIX__ : '';
    let p = pathname;
    if (prefix && p.indexOf(prefix) === 0) p = p.slice(prefix.length);
    p = p.replace(/^\/(en|zh)(?=\/|$)/, '');
    window.location.href = prefix + target + p + search + hash;
  };
  state = {
    activeNavItems:[],
    sideNav:false,
    btnFlag: true,
    status:""
  };
  createToggleNavItem = index => () => {
    let {activeNavItems} = this.state;
    activeNavItems[index] = !activeNavItems[index];
    this.setState({activeNavItems});
  };
/*  goIndex = () =>  {
	  console.log("@@@@")
	navigate('/');
  }; */
  toggleSideNav = () => {
    this.setState({sideNav:!this.state.sideNav});
  };

  render() {
    // let reactid = 0;
    let { intl } = this.props;
    let {activeNavItems,sideNav} = this.state;
    // console.log('nav-header props', this.props);
    //可以设置是否显示，首页需要单独设置第二页显示
    let msg = (id) => intl.formatMessage({ id });
    let hggg = HEADER_NAV;
    // console.log(this.props.location.pathname)
    let status = "/" + this.props.location.pathname.replace(new RegExp("(/|en|zh)","gm"),"");
    // console.log(status)
    let pgindex = this.props.location.hash;
             

    // if (this.props.location.hash === "#sectionTwo") {
    //   // this.setState({
    //       this.state.btnFlag = true
    //   // });
    // }else {
    //   this.state.btnFlag = false
    // }

    // console.log(this.state.btnFlag)
    if (pgindex||(pgindex === "" && (status === "/"||status === "/index.html"))) {
          this.state.btnFlag = false
    }else {
      this.state.btnFlag = true
    }

    // let Sys = {};
    // let ua = navigator.userAgent.toLowerCase();
    // let s;
    // (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :"";
    // if (Sys.ie) {
    //    this.state.btnFlag = true
    // }
    
        return (  
          <header className={styles.top} style={{display: this.state.btnFlag ? 'table' : 'none' }}>
            <div className={styles.main}>
              <div className={styles.logo}><a href="/"><img src={require('../assets/imgs/NavHeader/logo.png').default} alt=""/></a></div>
              <div className={styles.nav_bar}>
                <ul>
                  {/* {restatus ==='#1'?this.setState({isreload: true}):""} */}
                  {HEADER_NAV.map(({ to, txt, items }, i) => (    
                      <li style={{backgroundColor: (to === status) ? '#024753': '' }} key={i + '-' + txt}>
                          <Link to={to}>{msg(txt)}
                          {/* {items && <div className={styles.hid}>
                            <ul>{items.map(({ to, txt, src }) => <li key={txt}>
                                <Link to={to}>
                                  {src ? <><img src={src} />
                                  <p>{msg(txt)}</p>
                                  </> : msg(txt)}
                                </Link>
                              </li>)}
                            </ul>
                          </div>} */}
                          </Link>
                      </li>
                  ))}
                  <li><Link onClick={this.toggleLan} to='javascript:;'>{msg('nav_lang')}</Link></li>
                </ul>
                <button onClick={this.toggleSideNav} className={styles.burger}>
                  <span>menu</span>
                </button>
              </div>
            </div>
            {/*移动端导航*/}
            <nav className={[styles.sidenav,sideNav ? styles.show : ''].join(' ')}>
              <div className={styles.sidenav_brand}>
                <Link to={'/'}>冀德远健</Link>
              </div>
              {<ul className={styles.sidenav_menu}>
                {HEADER_NAV.map(({ to, txt, items, icon }, index) => (            
                        
                  <li>
                    <Link onClick={this.createToggleNavItem(index)} to={items ? 'javascript:;' : to}>
                      <Icon className={styles.sidenav_link_icon} name={icon}/>
                      <span className={styles.sidenav_link_title}>{msg(txt)}</span>
                      {/* {items ? <Icon name={activeNavItems[index] ? 'arrow_drop_up' : 'arrow_drop_down'}/> : null} */}
                    </Link>
                    {/* {items && <ul className={[styles.sidenav_dropdown,activeNavItems[index] ? styles.active : ''].join(' ')}>
                      <li><Link to={to}>{msg(txt)}</Link></li>
                      {items.map(({ to, txt }, i) => (
                        <li><Link to={to}>{msg(txt)}</Link></li>
                      ))}
                    </ul> } */}
                  </li>
                ))}
                <li><Link onClick={this.toggleLan} to='javascript:;'><Icon className={styles.sidenav_link_icon} name={'translate'}/><span className={styles.sidenav_link_title}>{msg('nav_lang')}</span></Link></li>
              </ul>}
            </nav>
          </header>
        );
    
  }
}

const Icon = ({className = styles.sidenav_dropdown_icon,name}) =>
  <i className={[className, 'material-icons'].join(' ')}>{name}</i>;

export default injectIntl(NavHeader);
